var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoged)?_c('div',{staticClass:"footer noprint"},[_c('div',{staticClass:"container-new-footer"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("reusable.footer.copyright", { year: _vm.currentYear }))+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }